import { action, observable } from 'mobx';
import { BroadcastChannel } from 'broadcast-channel';
import { BaseSessionStore } from './base-session.store';

export class SessionStore extends BaseSessionStore {
    @observable tabChannel: BroadcastChannel;
    @observable firstServiceTemplateId: string | null;

    @action.bound
    setTabChannel(tabChannel: BroadcastChannel) {
        this.tabChannel = tabChannel;
    }

    setFirstServiceTemplateId(id: string | null) {
        this.firstServiceTemplateId = id;
    }
}
